import 'styles/Loading.less'
import React, { Component, PropTypes } from 'react'
import classNames from 'classnames/bind'
import { connect } from 'react-redux'
import Spinner from './Spinner'

class Loading extends React.Component {
  render() {
    var {className, style, ...props} = this.props
    return (
      <div className={classNames('loading-component', className)} style={style}>
        <div className='loading-container'>
          <div className='loading-spinner'>
            <Spinner size={16} />
          </div>
        </div>
      </div>
    )
  }
}

Loading.contextTypes = {
  router: React.PropTypes.object.isRequired
}
Loading.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(Loading)



// WEBPACK FOOTER //
// ./src/components/Utils/Loading.js